exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d2-crud .d2-crud-header[data-v-cb8d3132]{border-bottom:1px dotted rgba(0,0,0,.2)}.d2-crud .d2-crud-body[data-v-cb8d3132]{padding:15px 0;overflow:hidden}.d2-crud .d2-crud-pagination[data-v-cb8d3132]{padding:15px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cb8d3132","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/d2-crud.vue
// module id = 10
// module chunks = 0